import { Plus, Save, X } from 'lucide-react';
import { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { ranks } from '../data/data';

Modal.setAppElement('#root');

const CardModal = ({ isOpen, onRequestClose, card, cardTypes }) => {
  const [title, setTitle] = useState(card?card.title:"");
  const [rank, setRank] = useState(card?card.rank:0);
  const [type, setType] = useState(card?card.type:0)
  const [img, setImg] = useState(card?card.img:"");
  const [description, setDescription] = useState(card?card.description:"");
  const [newId, setNewId] = useState(card&&card.id>0?card.id:-1)

  useEffect(() => {
    setTitle(card?card.title:"");
    setRank(card?card.rank:0);
    setType(card?card.type:0);
    setImg(card?card.img:"");
    setDescription(card?card.description:"");
    setNewId(card&&card.id>0?card.id:-1);
  },[card]);

  if (!isOpen) return null;

  const handleSaveCard = async () => {
    if (title!=="") {
      try {
        const response = await fetch(`/card`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ cardId:card?card.id:-1, newId, title, rank, type, img, description}),
        });
  
        if (response.ok) {
          onRequestClose();
        } else {
          alert(`Impossible d'enregistrer la carte. Vérifiez si une carte n'existe pas déjà avec cet ID.`);
        }
      } catch (error) {
        console.error('Error with /card endpoint.', error);
        alert(`Impossible d'enregistrer la carte. Vérifiez si une carte n'existe pas déjà avec cet ID.`);
      }
      //onRequestClose();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Card Edit"
      className="modal text-left"
      overlayClassName="modal-overlay"
    >
        <div onClick={onRequestClose} className='modal-cross'><X/></div>
        <div className='modal-form'>
          <div className='modal-label'>Titre & description</div>
          <input className='modal-input' type="text" value={title} onChange={(e) => setTitle(e.target.value)}/>
          <textarea className='modal-input' type="text" value={description} onChange={(e) => setDescription(e.target.value)}/>
        </div>
        <div className='modal-form'>
          <div className='modal-label'>Rareté</div>
          <select className='modal-input text-center' type="text" value={rank} onChange={(e) => setRank(e.target.value)} style={{backgroundColor:ranks[rank].color,fontFamily:"Starrysky"}}>
            {ranks.map(r => 
              <option key={r.title} value={r.id} style={{backgroundColor:r.color,fontFamily:"Starrysky"}}>{r.title}</option>
            )}
          </select>
        </div>
        <div className='modal-form'>
          <div className='modal-label'>Collection</div>
          <select className='modal-input text-center' type="text" value={type} onChange={(e) => setType(e.target.value)} style={{fontFamily:"Starrysky"}}>
            <option key={"none"} value={0} style={{fontFamily:"Starrysky"}}></option>
            {cardTypes.map(t => 
              <option key={t.title} value={t.id} style={{fontFamily:"Starrysky"}}>#{t.title}</option>
            )}
          </select>
        </div>
        <div className='modal-form'>
          <div className='modal-label'>Lien de l'image (optionnel)</div>
          <input className='modal-input' type="text" value={img} onChange={(e) => setImg(e.target.value)}/>
        </div>
        <div className='modal-form'>
          <div className='modal-label'>ID (optionnel)</div>
          <input className='modal-input' type="text" value={newId} onChange={(e) => setNewId(e.target.value)}/>
        </div>
        <div className='modal-form-buttons'>
          <h3 onClick={handleSaveCard} className='modal-button success'>{card.id===-1?<><Plus/>Ajouter la carte</>:<><Save/>Enregistrer</>}</h3>
        </div>
    </Modal>
  );
};

export default CardModal;
